/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_dimension.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the topological dimension of the supplied geometry.\nPoints and multi-points return `0`, lines and multi-lines return `1`, polygons and multi-polygons return `2`, and geometry collections return the maximum dimension of their components.',
  examples: [
    'ROW wkt = [\n    "POINT(1.0 2.0)",\n    "LINESTRING (30 10, 10 30, 40 40)",\n    "POLYGON ((30 10, 40 40, 20 40, 10 20, 30 10))"]\n| MV_EXPAND wkt\n| EVAL geometry = TO_GEOSHAPE(wkt),\n       type = ST_GEOMETRYTYPE(geometry),\n       topological_dimension = ST_DIMENSION(geometry)\n| KEEP type, topological_dimension',
  ],
  params: {
    geometry: 'Expression of type `geo_point`, `geo_shape`, `cartesian_point` or `cartesian_shape`. If `null`, the function returns `null`.',
  },
};

export default docs;
